import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface UserState {
  username: string;
  password: string;
  selectedLang: string;
  accessToken: string;
  refreshToken: string;
  loginSuccess: (params: {
    username: string;
    password: string;
    accessToken: string;
    refreshToken: string;
  }) => void;
  logout: () => void;
  storeTokens: (params: { accessToken: string; refreshToken: string }) => void;
  changeAccessToken: (accessToken: string) => void;
  changeLanguage: (selectedLang: string) => void;
}

export const useUserStore = create<UserState>()(
  devtools(
    persist(
      (set) => ({
        username: '',
        password: '',
        selectedLang: 'en',
        accessToken: '',
        refreshToken: '',
        loginSuccess: ({ username, password, accessToken, refreshToken }) =>
          set({ username, password, accessToken, refreshToken }),
        logout: () =>
          set({
            username: '',
            password: '',
            accessToken: '',
            refreshToken: ''
          }),
        storeTokens: ({ accessToken, refreshToken }) =>
          set({ accessToken, refreshToken }),
        changeAccessToken: (accessToken) => set({ accessToken }),
        changeLanguage: (selectedLang) => set({ selectedLang })
      }),
      { name: 'user-storage' }
    ),
    { name: 'UserStore' }
  )
);
